/**
 * Banner link rendering rules.
 *
 * Mirrors `HANDOFF_PROTOCOLS` in `@ordo/schema`'s banners manager (which owns
 * the authoring-time allowlist). Mirrored rather than imported: the client
 * never pulls in `@ordo/schema` — that would drag Prisma into the browser
 * bundle. Keep the two lists in step.
 */

/**
 * Schemes that hand off to a native app (dialer, mail client) instead of
 * navigating the page.
 */
const HANDOFF_LINK_PROTOCOLS = ['tel:', 'mailto:'] as const

/**
 * True when a banner link hands off to a native app. Those must render WITHOUT
 * `target="_blank"`: the OS takes over and the new tab is left blank. Web links
 * keep the new-tab behavior so the banner doesn't navigate the user away.
 */
export function isHandoffLink(link: string): boolean {
  const normalized = link.trim().toLowerCase()
  return HANDOFF_LINK_PROTOCOLS.some((protocol) => normalized.startsWith(protocol))
}
